import { dataSearch, isMounted } from '../../helpers/getter-commons';

const UNKNOWN = 'UNKNOWN';

// healthStatus info
const getHealthStatusMaster = (state) =>
  dataSearch(state.healthStatus.info.data, {
    list: true,
  });
export const getHealthStatus = getHealthStatusMaster;
export const isHealthStatusFetching = (state) =>
  state.healthStatus.info.isFetching;

const isHealthStatusMountedMaster = (state) =>
  isMounted(state.healthStatus.info.data);
export const isHealthStatusMounted = isHealthStatusMountedMaster;

export const getHealthStatusOrderApis = (state) => {
  let healthStatus = getHealthStatusMaster(state) || [];
  healthStatus =
    healthStatus.filter(({ service }) => service === 'order-api') || [];

  return healthStatus;
};

export const getOrderApiUpstox = (state) => {
  let status = UNKNOWN;

  let healthStatus = getHealthStatusMaster(state);
  healthStatus =
    healthStatus.find(
      ({ service, id }) => service === 'order-api' && id === 'upstox'
    ) || {};

  if (healthStatus && healthStatus.status) {
    status = healthStatus.status;
  }

  return status;
};

export const getOrderApiZerodha = (state) => {
  let status = UNKNOWN;

  let healthStatus = getHealthStatusMaster(state);
  healthStatus =
    healthStatus.find(
      ({ service, id }) => service === 'order-api' && id === 'zerodha'
    ) || {};

  if (healthStatus && healthStatus.status) {
    status = healthStatus.status;
  }

  return status;
};

export const getLiveFeed = (state) => {
  let status = '';

  let healthStatus = getHealthStatusMaster(state);

  healthStatus =
    healthStatus.find(({ service }) => service === 'live-feed') || {};

  if (healthStatus && healthStatus.status) {
    status = healthStatus.status;
  }

  return status;
};

export const getAlgosApi = (state) =>
  getHealthStatusMaster(state).filter(({ service }) => service === 'algo') ||
  [];

export const getAlgoApi = (state, algoId) =>
  getHealthStatusMaster(state).find(
    ({ service, id }) => service === 'algo' && id === algoId
  ) || {};
